import { gql } from 'graphql-request';
import { PortfolioSiteMetric } from 'src/shared/types/graph/portfolio';

export const siteSummaryQuery = gql`
    query getSiteSummary($customerId: String!, $siteId: String!) {
        siteSummary {
            getSite(customerId: $customerId, siteId: $siteId) {
                id
                name
                totalArea
                country
                metrics {
                    name
                    label
                    frameworks
                    ... on MultiMetricSingleYearSiteMetric {
                        year
                        metrics
                    }
                    ... on SingleYearSiteMetric {
                        year
                        data
                    }
                    ... on MultiYearSiteMetric {
                        years
                        datum
                    }
                    ... on MultiYearMetricSingleYearSiteMetric {
                        years
                        metricWithTrend
                        yearCoverage {
                            year
                            assetCount
                            complete
                        }
                    }
                }
            }
        }
    }
`;

export type SiteSummarySpeciesChartData = {
    iucnRedListCategory: string;
    count: number;
};

export type SiteSummaryRedListSpecies = {
    count: number;
    siteCount: number;
    chartData: SiteSummarySpeciesChartData[];
};

export type SiteSummaryInvasiveSpecies = {
    count: number;
    siteCount: number;
};

export type SiteSummaryPredictedSpecies = {
    totalCount: number;
    redListSpecies: SiteSummaryRedListSpecies;
    invasiveSpecies: SiteSummaryInvasiveSpecies;
};

export type SiteSummaryData = {
    id: string;
    name: string;
    totalArea: number;
    country: string;
    metrics: PortfolioSiteMetric[];
};

export type SiteSummaryQueryResult = {
    siteSummary: {
        getSite: SiteSummaryData;
    };
};
